// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".truncate[data-v-08a5c016]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", "",{"version":3,"sources":["webpack://./resources/js/Components/InvoiceList.vue"],"names":[],"mappings":"AACA,2BAEE,eAAA,CACA,sBAAA,CAFA,kBAEF","sourcesContent":["\n.truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
